import { render, staticRenderFns } from "./ObrigadoAlmaGemea.vue?vue&type=template&id=2fd2be30"
import script from "./ObrigadoAlmaGemea.vue?vue&type=script&lang=js"
export * from "./ObrigadoAlmaGemea.vue?vue&type=script&lang=js"
import style0 from "./ObrigadoAlmaGemea.vue?vue&type=style&index=0&id=2fd2be30&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports